"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonUtil = void 0;
var log_1 = require("./log");
var JsonUtil = /** @class */ (function () {
    function JsonUtil() {
    }
    JsonUtil.parseJson = function (text) {
        var result;
        try {
            result = JSON.parse(text);
        }
        catch (error) {
            log_1.ConnectionLog.error("parseJson: error = " + error + ".");
        }
        return result;
    };
    JsonUtil.jsonStringify = function (obj) {
        var result = '';
        try {
            result = JSON.stringify(obj);
        }
        catch (error) {
            log_1.ConnectionLog.error("jsonStringify: error = " + error + ".");
        }
        return result;
    };
    return JsonUtil;
}());
exports.JsonUtil = JsonUtil;
